import React from 'react';
import PropTypes from 'prop-types';

const LoginButton = ({ text, type, disabled, testId }) => (
  <button
    type={ type === 'submit' ? 'submit' : 'button' }
    disabled={ disabled }
    data-testid={ testId }
  >
    {text}
  </button>
);

LoginButton.propTypes = {
  text: PropTypes.string.isRequired,
  testId: PropTypes.string.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool,
};

LoginButton.defaultProps = {
  type: 'button',
  disabled: false,
};

export default LoginButton;
